// extracted by mini-css-extract-plugin
export var pageTitleWrapper = "index-module--page-title-wrapper--FNgnI";
export var previewSection = "index-module--preview-section--A68Kl";